/**
 * Source-of-truth design tokens for waveform visuals (icon + pill).
 * SVG viewbox values define the canonical proportions;
 * pixel values for the active pill are derived from them.
 */

// SVG viewbox dimensions (used by WaveformIcon)
export const WAVEFORM_VIEWBOX = 100;
export const WAVEFORM_BAR_WIDTH = 6;
export const WAVEFORM_BAR_GAP = 6;
export const WAVEFORM_BAR_MAX_HEIGHT = 48;
export const WAVEFORM_BAR_SCALES = [0.5, 1.0, 0.75, 0.5];

// Icon render size (px)
export const WAVEFORM_ICON_SIZE = 34;

// Derived pixel values for the active pill
const scale = WAVEFORM_ICON_SIZE / WAVEFORM_VIEWBOX;
export const PILL_BAR_COUNT = WAVEFORM_BAR_SCALES.length;
export const PILL_BAR_WIDTH_PX = Math.round(WAVEFORM_BAR_WIDTH * scale);
export const PILL_BAR_GAP_PX = Math.round(WAVEFORM_BAR_GAP * scale);
const iconBarMaxHeightPx = Math.round(WAVEFORM_BAR_MAX_HEIGHT * scale);

// Pill container is taller than the icon's bar height so bars have room
// to grow beyond the resting state when reacting to real audio.
export const PILL_BAR_MAX_HEIGHT_PX = 24;

// Animation half-height params for useWaveformAnimation (which writes height = halfHeight * 2).
// At silence (level=0) bars collapse to dot size (PILL_BAR_WIDTH_PX).
// ANIM_HALF_MAX is set so moderate speech (~0.5 level) reaches iconBarMaxHeightPx.
export const ANIM_HALF_MIN = PILL_BAR_WIDTH_PX / 2;
export const ANIM_HALF_MAX = iconBarMaxHeightPx - ANIM_HALF_MIN;

// Processing dots reuse bar sizing for visual consistency
export const PILL_DOT_COUNT = 3;
